import Vue from 'vue'
import get from 'lodash/get'
import dayjs from 'dayjs'
import LocaleService from 'services/LocaleService'
import AuthService from 'services/AuthService'
import ValidationService from 'services/ValidationService'
import { importComponents } from '~/helpers'
import { directive as clickaway } from 'vue-clickaway'

Vue.mixin({
    components: {
        ...importComponents(require.context('components/common')),
    },

    methods: {
        $get(object, path, defaultValue) {
            return get(object, path, defaultValue)
        },

        env(name) {
            return env(name)
        },

        isEnv(envs) {
            let isEnv = false

            if (!Array.isArray(envs)) {
                envs = [envs]
            }

            envs.forEach((env) => {
                if (env('VUE_APP_ENV') === env) {
                    isEnv = true
                }
            })

            return isEnv
        },

        isDescendant(child, parent) {
            let node = child.parentNode

            while (node !== null) {
                if (node === parent) {
                    return true
                }

                node = node.parentNode
            }

            return false
        },

        emitEvent({ name, payload }, ignoredEvents = []) {
            if (ignoredEvents.includes(name)) {
                return
            }

            this.$emit(name, payload)
            this.$emit('emitEvent', { name, payload })
        },
    },

    filters: {
        dayjs(date, format) {
            return dayjs(date).format(format)
        },
    },

    directives: {
        clickaway,
    },

    beforeCreate() {
        Vue.prototype.$locale = LocaleService
        Vue.prototype.$auth = AuthService
        Vue.prototype.$validation = ValidationService
    },
})
